export default {
    namespaced: true,
    state: {
        title: "",
        questions: []
    },
    mutations: {
        SET_CURRENT_TITLE(state, title = "") {
            state.title = title
        },
        SET_CURRENT_QUESTIONS(state, questions = []) {
            state.questions = questions
        }
    }
}
